import { useAuth } from '../AuthContext';
import axios from 'axios';
import '../profile.css';
import UserStatus from './UserStatus';
import API from '../api';
import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';


const validatePassword = (password) => {
  const rules = [
    { regex: /.{8,}/, message: 'At least 8 characters' },
    { regex: /[A-Z]/, message: 'At least 1 uppercase letter' },
    { regex: /[a-z]/, message: 'At least 1 lowercase letter' },
    { regex: /[0-9]/, message: 'At least 1 number' },
    { regex: /[^A-Za-z0-9]/, message: 'At least 1 special character' },
  ];

  const failed = rules.filter(rule => !rule.regex.test(password));
  return {
    isValid: failed.length === 0,
    errors: failed.map(f => f.message)
  };
};


const Profile = () => {
  const { user, login } = useAuth();
  const [profile, setProfile] = useState({ name: '', email: '', phone: '' });
  const [phoneNumber, setPhoneNumber] = useState('');
  const [whatsapp_SMS, setWhatsappSMS] = useState('');
  const [message, setMessage] = useState('');
  const [subscription, setSubscription] = useState(null);
  const [plan, setPlan] = useState(null);
  const [expiry_date, setExpiryDate] = useState('');
  const [start_date, setStartDate] = useState('');
  const [passwordErrors, setPasswordErrors] = useState([]);
  const [matchError, setMatchError] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [saveMessage, setSaveMessage] = useState('');
  const isSavingRef = useRef(false);  // to track ongoing save/throttle  
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= 769);
    
  useEffect(() => {
      const handleResize = () => {
        if (window.innerWidth >= 769) {
          setSidebarOpen(true);  // open sidebar on desktop
        } else {
          setSidebarOpen(false); // closed on mobile
        }
      };
  
      handleResize(); // run on mount
  
      // Optional: listen for window resize to update sidebar automatically
      window.addEventListener('resize', handleResize);
  
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    const toggleSidebar = () => {
      setSidebarOpen(prev => !prev);
    };
  
  const formatDate = (datetime) => {
    const date = new Date(datetime);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  useEffect(() => {
    document.title = "Profile | TradeBarta.com";
  }, []);
  

  useEffect(() => {
    fetchuserdetails();
    if (!user?.id) return;
    fetchSubscription();
  }, [user]);

  useEffect(() => {
    if (!user?.id || !plan) return;
    setSubscription(plan === 1 ? 'Free Trial' : plan === 2 ? 'Silver' : plan === 3 ? 'Gold' : 'Platinum');
  }, [user, plan]);

  const fetchuserdetails = async () => {
    try {
      if (user) {
        const res = await API.get('/userdetails', { params: { user_id: user?.id } });
        setProfile({ name: res.data.name || '', email: user.email || '', phone: res.data.phone_number || ''});
      }
    } catch (err) {
      console.error('User load failed', err);
    }
  };

  const fetchSubscription = async () => {
    try {
      if (user) {
        const res = await API.get('/packageid', { params: { user_id: user?.id } });
        setPlan(res.data.package_id || '');
        setStartDate(formatDate(res.data.start_date) || '');
        setExpiryDate(formatDate(res.data.expiry_date) || '');
      }
    } catch (err) {
      console.error('Subscription load failed', err);
    }
  };

  const handleProfileChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

const handlePasswordChange = (value) => {
    setNewPassword(value);
    const result = validatePassword(value);
    setPasswordErrors(result.errors);
    if (confirmPassword && value !== confirmPassword) {
      setMatchError('Passwords do not match');
    } else {
      setMatchError('');
    }
  };

  const handleConfirmChange = (value) => {
    setConfirmPassword(value);
    if (newPassword && value !== newPassword) {
      setMatchError('Passwords do not match');
    } else {
      setMatchError('');
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    const user_id = user?.id;
  
    setMessage(null);
    setError(null);

     if (isSavingRef.current) {
      setMessage('Please wait for 5 min before saving again.');
      return; // Ignore if already saving or throttled
    }

    isSavingRef.current = true; // block further saves for now

    const { isValid, errors } = validatePassword(newPassword);
    if (!newPassword || !confirmPassword) {
      setError('Please fill in all fields.');
      return;
    }
    if (!isValid) {
      setError('Password does not meet requirements.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    try {
      const res = await fetch('/api/change-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id, newPassword }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || 'Failed to update password.');
      } else {
        setMessage(data.message || 'Password changed successfully.');
       // setTimeout(() => navigate('/login'), 2000);
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }

    // Throttle duration: block for 5 min after save
    setTimeout(() => {
      isSavingRef.current = false;
    }, 300000);
  };

  return (
    <div className='dashboard-wrapper'>
          {/* Top Navigation Bar */}
      <header className="header-container">
  <a href="/" className="logo">
    <img src={require("../images/logo.png")} alt="Logo" />
  </a>              
                    <button className="menu-toggle" onClick={toggleSidebar}>☰</button>  
     <UserStatus />
          </header>       
      {/* Sidebar and Main Content */}
                    
   <div className={`dashboard-container ${sidebarOpen ? 'sidebar-open' : ''}`}>
  
     <aside className={`sidebar ${sidebarOpen ? 'show-sidebar' : ''}`}>
        <ul>
          <li><a href="/dashboard">Dashboard</a></li>
          <li><a href="/payment_history">Billing and Payment History</a></li>
          <li><a href="/referral_dashboard">Refer & Win</a></li>
          <li><a href="/profile">My Profile</a></li>
          <li><a href="/contact_us">Support</a></li>
        </ul>
      </aside>

      <main className="main-content">
  
        <section className="data-table">
          <h4>👤 Personal Information</h4>
          <div className="row-in">
            <label>Name:</label>
            <input name="name" value={profile.name} disabled />

            <label>Email:</label>
            <input name="email" value={profile.email} disabled />
          </div>
        </section>

        <section className="data-table">
          <h4>📦 Subscription</h4>
          <div className="row-in">
            <label>Current Plan:</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <strong>{subscription}</strong>
              <a className="button" href="/change_plan">Change Plan</a>
            </div>

            <label>Start Date:</label>
            <input name="start_date" value={start_date} disabled />

            <label>Expiry Date:</label>
            <input name="expiry_date" value={expiry_date} disabled />
          </div>
        </section>

        <section className="data-table">
          <h4>🔒 Change Password</h4>
          <div className="row-in">
            <label>New Password:</label>
            <input type="password" name="new" value={newPassword} 
            onChange={(e) => handlePasswordChange(e.target.value)} />
            {passwordErrors.length > 0 && (
                            <ul style={{ color: 'red', fontSize: '14px', paddingLeft: 16, marginTop: 5 }}>
                              {passwordErrors.map((err, idx) => (
                                <li key={idx}>{err}</li>
                              ))}
                            </ul>
                          )}

            <label>Confirm Password:</label>
            <input type="password" name="confirm" value={confirmPassword} 
                onChange={(e) => handleConfirmChange(e.target.value)} />
          </div>

          {matchError && (
            <div style={{ color: 'red', fontSize: '14px', marginTop: 5 }}>{matchError}</div>
          )}

          <div className="button-wrapper">
            <button onClick={handleChangePassword}>Update</button>
          </div>

          {message && (
            <p style={{ textAlign: "center", color: message.includes('success') ? 'green' : 'red' }}>
              {message}
            </p>
          )}
        </section>
      </main>
    </div>
    </div>
  );
};

export default Profile;
